import { Button, Flex } from "antd";
import useWepapp from "../hook/useWepapp";
import { useMediaQuery } from "react-responsive";
const { Outlet } = require("react-router-dom")

const UserComponent = ({
    Head = "",
    profile1 = () => { },
    exit = () => { },
    navBar = () => { },
}) => {
    const { goToMenu = () => { } } = useWepapp()
    const isPortrait = useMediaQuery({ orientation: 'portrait' })
    return (
        <Flex vertical>
            <Flex style={{ display: "flex", flexDirection: "column", height: "100vh", backgroundColor: "#FCF9F6", padding: "5vh", gap: "2vh" }}>
                {profile1()}
                {exit()}

            </Flex>
            {navBar()}
        </Flex>
    )
}
export default UserComponent;